let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aKPRl")).then(() => parcelRequire('lahHp'));